// extracted by mini-css-extract-plugin
export var arrow = "_cm-1";
export var content = "_cm-0";
export var highlighted = "_cm-2";